import { useState } from 'react';
import { faqItems } from '@/mocks/faq';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchemaData = {
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
      <SchemaOrg type="FAQPage" data={faqSchemaData} />
      <div className="text-center mb-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          常见问题
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          关于免费看片平台你最关心的问题，这里都有答案
        </p>
      </div>
      <div className="max-w-3xl mx-auto space-y-3">
        {faqItems.map((item, index) => (
          <div
            key={index}
            className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
          >
            <button
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <span className="text-sm font-medium text-foreground-900 pr-4">{item.question}</span>
              <i
                className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-500 transition-transform duration-300 shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              ></i>
            </button>
            {openIndex === index && (
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}